"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const pluralize_1 = __importDefault(require("pluralize"));
const formatTimeSpan = (endDate, startDate, addSuffix = true) => {
    // `distanceInWords` does not support weeks resolution
    const fullWeeks = Math.abs(date_fns_1.differenceInWeeks(endDate, startDate));
    if (fullWeeks > 0 && fullWeeks < 4) {
        const remainderDays = Math.abs(date_fns_1.differenceInDays(endDate, startDate)) % 7;
        const weeks = remainderDays < 4 ? fullWeeks : fullWeeks + 1;
        const isEndAfter = date_fns_1.isAfter(startDate, endDate);
        const prefix = addSuffix && isEndAfter ? 'in ' : '';
        const suffix = addSuffix && !isEndAfter ? ' ago' : '';
        return `${prefix}${weeks} ${pluralize_1.default('week', weeks)}${suffix}`;
    }
    return date_fns_1.distanceInWordsStrict(endDate, startDate, { addSuffix });
};
exports.default = formatTimeSpan;
